/**
 * i18n configuration for Tabel.kz.
 * Supported: ru (Русский), kk (Қазақша), en (English).
 * Detection order: localStorage → navigator language → fallback 'ru'.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ru from "./locales/ru.json";
import kk from "./locales/kk.json";
import en from "./locales/en.json";
import termsRu from "./locales/legal/terms.ru.json";
import termsKk from "./locales/legal/terms.kk.json";
import termsEn from "./locales/legal/terms.en.json";
import privacyRu from "./locales/legal/privacy.ru.json";
import privacyKk from "./locales/legal/privacy.kk.json";
import privacyEn from "./locales/legal/privacy.en.json";

export const SUPPORTED_LANGS = [
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "kk", label: "Қазақша", flag: "🇰🇿" },
  { code: "en", label: "English", flag: "🇬🇧" },
];

const withLegal = (base, terms, privacy) => ({
  ...base,
  legal: {
    ...base.legal,
    terms_page: terms,
    privacy_page: privacy,
  },
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: withLegal(ru, termsRu, privacyRu) },
      kk: { translation: withLegal(kk, termsKk, privacyKk) },
      en: { translation: withLegal(en, termsEn, privacyEn) },
    },
    fallbackLng: "ru",
    supportedLngs: ["ru", "kk", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "tabel.lang",
    },
  });

export default i18n;
